<script>
export default {
  computed: {
    staffList () {
      let docs

      if (this.$route.meta.version === 'raz') {
        docs = this.docs.razstaff
      } else {
        docs = this.docs.staff
      }

      const staff = {}

      Object.keys(docs).forEach(id => {
        if (docs[id].type === 'staff') {
          staff[id] = docs[id]
        }
      })

      return staff
    },

    castList () {
      let docs

      if (this.$route.meta.version === 'raz') {
        docs = this.docs.razstaff
      } else {
        docs = this.docs.staff
      }

      const cast = {}

      Object.keys(docs).forEach(id => {
        if (docs[id].type === 'cast') {
          cast[id] = docs[id]
        }
      })

      return cast
    }
  }
}
</script>

<template>
  <div class="gp-staff-list">
    <section class="staff-list has-text-weight-bold">
      <ul class="level-left">
        <li
          v-for="(staff, staffId) in staffList"
          :key="staffId"
        >
          <div class="title is-size-5 is-size-6-mobile">{{ staff.title }}</div>
          <div class="level is-mobile">
            <span class="is-size-3 is-size-4-mobile">{{ staff.name }}</span>
            <router-link
              v-if="staff.comment"
              :to="{
                name: $route.meta.version === 'raz' ? 'raz-staff-article' : 'staff-article',
                params: { 'staffId': staffId }
              }"
            >
              <span class="comment">
                <img src="@/assets/icon-comment.png" alt="COMMENT">
              </span>
            </router-link>
          </div>
        </li>
      </ul>
    </section>

    <section class="cast-list has-text-weight-bold">
      <ul class="level-left">
        <li
          v-for="(cast, castId) in castList"
          :key="castId"
        >
          <div class="title">{{ cast.title }}</div>
          <div class="level is-mobile">
            <span class="name is-size-2 is-size-4-mobile">{{ cast.name }}</span>
            <router-link
              v-if="cast.comment"
              :to="{
                name: $route.meta.version === 'raz' ? 'raz-staff-article' : 'staff-article',
                params: { 'staffId': castId }
              }"
            >
              <span class="comment">
                <img src="@/assets/icon-comment.png" alt="COMMENT">
              </span>
            </router-link>
          </div>
        </li>
      </ul>
    </section>

    <transition name="slide-up">
      <router-view/>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.gp-staff-list {
  @include is-not-mobile {
    max-width: 60rem;
    margin: auto;
    padding: 0 3rem;
  }
  section {
    background-color: $black-transparent;
    color: $white;
    @include is-mobile {
      margin: 0 1rem;
      margin-bottom: 1.5rem;
      padding: 1.5rem 1.5rem;
    }
    @include is-not-mobile {
      margin-bottom: 2.5rem;
      padding: .5rem 2rem;
    }
    > ul {
      @include is-not-mobile {
        flex-wrap: wrap;
      }
      li {
        @include is-mobile {
          &:not(:last-child) {
            margin-bottom: 1rem;
          }
        }
        @include is-not-mobile {
          margin: 1.75rem 0;
          @media screen and (max-width: 1200px) {
            width: calc(100% / 2 - .75rem);
            &:not(:nth-child(2n)) {
              margin-right: 1.5rem;
            }
          }
          @media screen and (min-width: 1201px) {
            width: calc(99% / 3 - 1rem);/* 100%だとIE, Edgeでレイアウトが崩れたため */
            &:not(:nth-child(3n)) {
              margin-right: 1.5rem;
            }
          }
          .title {
            white-space: nowrap;
          }
          .level {
            flex-wrap: wrap;
          }
          .name {
            white-space: nowrap;
          }
        }
      }
    }
    .title {
      color: $pink;
      padding-bottom: .25rem;
    }
    .comment img {
      width: 7rem;
      height: 1.5rem;
    }
    .comment img:hover {
      transform: translate(2px, 2px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/staff/staff-list.vue